"use client"; 
import { useState } from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import cl1Tab from "@/Helper/images/client_centric_approach.png";
import cl2Tab from "@/Helper/images/commitment_to_innovation.png";
import cl3Tab from "@/Helper/images/ethical_data_practices.png";
import cl4Tab from "@/Helper/images/end_to_end_expertise.png";

import Image from "next/image";

export default function IndustryComponent() {
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  const handleTabClick = (index) => {
    setActiveTab(index); // Update the active tab state
  };

  const tabTitles = [
    "Client-Centric Approach",
    "Commitment to Innovation",
    "Ethical Data Practices",
    "End-to-End Expertise",
   
  ];

  const tabContent = [
    {
      heading: "Client-Centric Approach",
      subheading: "Your goals are our mission. We work closely with you to understand your unique challenges and objectives, providing solutions that align seamlessly with your business strategy.",
      image: cl1Tab, 
    },
    {
      heading: "Commitment to Innovation",
      subheading: " We leverage the latest advancements in AI, machine learning, and cloud technology to deliver solutions that are both innovative and practical. ",
      image: cl2Tab,
    },
    {
      heading: "Ethical Data Practices",
      subheading: " We prioritize responsible data management and governance, ensuring compliance with industry standards and protecting your data assets.",
      image: cl3Tab,
    },
    {
      heading: "End-to-End Expertise",
      subheading: "From data strategy to execution, our team of skilled professionals provides comprehensive support across every phase of your data journey.",
      image: cl4Tab,
    },
   
  ];

  return (
    <div className="industry_cat_section1">
      {/* Navigation Tabs */}
      <div className="industry_cat_nav1">
        {tabTitles.map((tab, index) => (
          <p
            key={index}
            className={index === activeTab ? "active" : ""}
            onClick={() => handleTabClick(index)}
            
          >
            {tab}
          </p>
        ))}
      </div>

      {/* Tab Content */}
      {tabContent.map((content, index) => (
        <div
          key={index}
          className={`industry_container1 ${
            index === activeTab ? "active" : ""
          }`}
        >
          <div className="industry_left_content1">
            <p className="heading1">{content.heading}</p>
            <p className="subheading1">{content.subheading}</p>
           
          </div>
          <div className="industry_right_content1">
            <div className="slider_bg1 normal_bg1">
            <Image
              src={tabContent[activeTab].image}
              alt={tabContent[activeTab].heading}
              width={457}
              height={257}
              className="productbanner_imageslider"
              loading="eager"
            />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
